import { useNavigate } from 'react-router-dom'

import { CodeXmlIcon } from '@buffer-mono/popcorn'

import { settingsDeveloperRoute } from '~publish/legacy/routes'

import { TaskCard } from './TaskCard'
import { useTryBufferApiStatus } from './useTaskCardStatus'

import type { JSX } from 'react'

export function TryBufferApiCard(): JSX.Element {
  const navigate = useNavigate()
  const { status, markComplete } = useTryBufferApiStatus()

  const handleTryBufferApi = (): void => {
    navigate(settingsDeveloperRoute.route)
  }

  return (
    <TaskCard status={status}>
      <TaskCard.CompleteAction onClick={markComplete} />
      <TaskCard.Header>
        <TaskCard.Title>3. Explore Buffer API</TaskCard.Title>
      </TaskCard.Header>
      <TaskCard.Description>
        Connect to your agents, automation tools, and more.
      </TaskCard.Description>
      <TaskCard.Footer>
        <TaskCard.PrimaryAction onClick={handleTryBufferApi}>
          <CodeXmlIcon />
          Get Started
        </TaskCard.PrimaryAction>
        <TaskCard.CompletedLabel>Buffer API Tested</TaskCard.CompletedLabel>
      </TaskCard.Footer>
    </TaskCard>
  )
}
